"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useMutationObserver = function (ref, options) {
    if (options === void 0) { options = { attributes: true, childList: true, subtree: true }; }
    var observer;
    var _a = (0, react_1.useState)(), mutations = _a[0], setMutations = _a[1];
    (0, react_1.useEffect)(function () {
        var callback = function (mutationsList) {
            setMutations(mutationsList);
        };
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            observer = new MutationObserver(callback);
            observer.observe(ref.current, options);
        }
        return function () {
            observer.disconnect();
        };
    }, [ref === null || ref === void 0 ? void 0 : ref.current]);
    return mutations;
};
exports.default = useMutationObserver;
